"use strict";

Shopify.theme.jsWebinarPopup = {
  init: function init($section) {
    var _this = this;

    Shopify.theme.jsWebinarPopup = $.extend(this, Shopify.theme.getSectionData($section));

    var cookieName = this.cookie_name || 'webinar-popup';
    var cookieValue = typeof Cookies !== 'undefined' ? Cookies.get(cookieName) : null;
    var cookieEnabled = parseInt(this.popup_days_to_hide, 10) !== 0;

    if (Shopify.designMode) {
      return;
    }

    if (cookieEnabled && cookieValue === 'opened') {
      return false;
    }

    setTimeout(function () {
      _this.open();
    }, (parseFloat(this.popup_delay) || 0) * 1000);

    if (cookieEnabled && typeof Cookies !== 'undefined') {
      Cookies.set(cookieName, 'opened', {
        expires: parseInt(this.popup_days_to_hide, 10)
      });
    }
  },
  open: function open() {
    var _this2 = this;

    if (this.show_popup_on_mobile === false && window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    $.fancybox.open({
      src: '[data-webinar-popup]',
      type: 'inline',
      opts: {
        baseClass: 'webinar-popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        arrows: false,
        buttons: [],
        touch: false,
        keyboard: true,
        wheel: false,
        trapFocus: true,
        autoFocus: false,
        backFocus: false,
        afterShow: function afterShow() {
          $(document).on('click.webinarPopup', '.webinar-popup__close', function () {
            _this2.close();
          });
        },
        beforeClose: function beforeClose() {
          $(document).off('click.webinarPopup', '.webinar-popup__close');
        }
      }
    });
  },
  close: function close() {
    $.fancybox.close($('[data-webinar-popup]'));
  },
  showThemeEditorState: function showThemeEditorState() {
    $('.webinar-popup-section').addClass('is-fixed-top');
    this.open();
  },
  hideThemeEditorState: function hideThemeEditorState() {
    $('.webinar-popup-section').removeClass('is-fixed-top');
    this.close();
  },
  unload: function unload($section) {
    $(document).off('click.webinarPopup', '.webinar-popup__close');
    $.fancybox.destroy();
    $('.webinar-popup-modal .fancybox-slide').empty();
  }
};
